/*                                                   */
import type Stores from "@kestrel/stores";
import { getContext } from "svelte";
import { writable } from "svelte/store";
import type { ResolvedComponent } from "@kestrel/internal/client";
import type { ServerResult } from "@kestrel/stores";
import { clientOnly } from "../../utils/universal";
import { goto } from "./goto.js";
import { getNavigationTargetFromUrl } from "./utils.js";

/**
 *
 */
export const clientContext = "__kestrel__" as const;

/**
 *
 *
 *
 *
 *
 *
 *
 */
export const createStores = (
  state: ServerResult,
  resolvedComponent: ResolvedComponent | undefined,
): Stores.KestrelStores => ({
  initial: writable(state),
  data: writable(state.data),
  form: writable(state.form),
  error: writable(state.error),
  routeId: writable(state.routeId),
  routePath: writable(state.routePath),
  component: writable(resolvedComponent),
  navScopes: {},
});

/**
 *
 */
export const getStores: typeof Stores.getStores = () =>
  getContext<Stores.KestrelStores>(clientContext);

/**
 *
 */
export const data: (typeof Stores)["data"] = {
  subscribe: (run, invalidate) => getStores().data.subscribe(run, invalidate),
};

/**
 *
 *
 *
 */
export const updateCallback = (stores: Stores.KestrelStores, result: Stores.ServerResult): void => {
  stores.data.set(result.data);
  stores.routeId.set(result.routeId);
  stores.routePath.set(result.routePath);
  stores.error.set(result.error);
};

/**
 *
 */
export const useRefresh: typeof Stores.useRefresh = clientOnly((options = {}) => {
  const stores = getStores();

  return async (urlOrUpdate) => {
    const to = await getNavigationTargetFromUrl(stores, urlOrUpdate, options.base);
    return goto(stores, options, to, "reload", updateCallback) as never;
  };
});
